// extracted by mini-css-extract-plugin
module.exports = {"paginator":"styles-module--paginator--2zpIN","link":"styles-module--link--1l59s","linkNext":"styles-module--linkNext--Wzu4u","linkPrevious":"styles-module--linkPrevious--3rCeG"};